import styled, { css } from "styled-components"
import CheckmarkIconUrl from "images/checkmark.svg"
import CheckmarkInvIconUrl from "images/checkmark-inv.svg"
import { maxWidth, eq, transparentize } from "utils"

export const Container = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "block")};
  padding: 6rem;
  padding-left: calc((100% - 74rem) / 2);
  padding-right: calc((100% - 74rem) / 2);

  ${maxWidth.tablet`
    padding: 6rem 4rem;
  `}

  ${maxWidth.mobile`
    padding: 4rem 2rem;
  `}

  background-color: ${(props) => props.theme.component.background};
  color: ${(props) => props.theme.component.text};

  button {
    margin: 4.5rem auto 0 auto;
  }
`

const ListItemStyle = css`
  li {
    position: relative;
    display: flex;

    font-size: 2rem;
    line-height: 2.9rem;

    &:not(:last-child) {
      border-bottom: 0.1rem solid ${(props) => transparentize(0.93, props.theme.component.text)};
    }

    &:last-child {
      border-bottom: 0.3rem solid ${(props) => transparentize(0.93, props.theme.component.text)};
    }

    p {
      margin: 2.2rem 0;
    }
  }

  li::before {
    display: flex;
    flex-shrink: 0;
    background-color: ${(props) => transparentize(0.95, props.theme.component.text)};

    border-radius: 100%;
    width: 2.9rem;
    height: 2.9rem;
    align-items: center;
    justify-content: center;
    margin-top: 2.2rem;

    font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 1.6rem;
    font-weight: 400;
    margin-right: 1.5rem;
    color: ${(props) => transparentize(0.5, props.theme.component.text)};
  }
`

export const ContainerOrdered = styled.ol`
  list-style-type: none;
  margin: 0;
  padding: 0;
  counter-reset: mbg-list-counter;
  border-top: 0.5rem solid ${(props) => transparentize(0.93, props.theme.component.text)};

  ${ListItemStyle};

  li {
    counter-increment: mbg-list-counter;
  }

  li::before {
    content: counter(mbg-list-counter);

    ${eq("bulletType", "None")`
      content: counter(mbg-list-counter) ".";
      display: inline-block;
      background: none;
      font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 3rem;
      line-height: 2.9rem;
      color: ${(props) => props.theme.component.text};
    `}
  }
`

export const ContainerUnordered = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  border-top: 0.5rem solid ${(props) => transparentize(0.93, props.theme.component.text)};

  ${ListItemStyle};

  li::before {
    ${eq("bulletType", "Bullet")`
      content: "*";
      font-size: 2.5rem;
      padding-top: 1rem;
      height: 1.9rem;
    `}

    ${eq("bulletType", "Checkmark")`
      content: "";
      background-image: url(${CheckmarkIconUrl});
      ${(props) =>
        props.theme.component.isDarkBackground &&
        `
        background-image: url(${CheckmarkInvIconUrl});
      `}
      background-size: 60% 60%;
      background-repeat: no-repeat;
      background-position: 0.6rem 0.6rem;
    `}
  }
`
